import styled from '@emotion/styled';
import { Component } from 'react';

const ContactBody = styled.div`
  background-image: url(${props => props.backgroundImageUrl});
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
  padding: 6em 1em 1em;
  position: relative;
  width: 100%;

  @media (max-width: 480px) {
    background-size: 200%;
    padding-top: 5.25em;
  }
`;

const ContentHeader = styled.div`
  display: inline-block;
  padding: 1em;
  position: relative;
  width: 100%;

  @media (max-width: 480px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const BackLink = styled.a`
  align-items: center;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  line-height: 150%;
  width: 100%;
  text-decoration: none;

  &:before {
    align-self: center;
    content: '';
    display: inline-block;
    font-family: icomoon;
    line-height: 1;
    margin-right: 0.5em;
    position: relative;
    transform: scaleX(-1) translate(0, -10%);
  }

  &:hover {
    color: #ffffff;
  }
`;

const RoofingDiagram = styled.div`
  background-image: url(${props => props.imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 82%;
  position: absolute;
  right: -30%;
  top: 52%;
  transform: translateY(-50%);
  width: 92%;

  @media (max-width: 600px) {
    height: 68%;
    right: -29%;
    width: 82%;
  }

  @media (max-width: 480px) {
    height: auto;
    margin-bottom: 1em;
    padding-bottom: 75%;
    position: relative;
    right: auto;
    transform: none;
    width: 100%;
  }
`;

const Content = styled.div`
  display: inline-block;
  max-width: 440px;
  min-height: 32em;
  padding: 1em 1em 4.4em;
  position: relative;
  width: 80%;

  @media (max-width: 600px) {
    max-width: 350px;
    min-height: 28em;
    padding-bottom: 4em;
  }

  @media (max-width: 480px) {
    max-width: none;
    min-height: 13.5em;
    padding-bottom: 3.6em;
    width: 100%;
  }
`;

const Heading = styled.div`
  font-size: 2.222em;
  font-weight: 700;
  line-height: 120%;
  padding: 4em 0;

  @media (max-width: 600px) {
    font-size: 2em;
  }

  @media (max-width: 480px) {
    font-size: 1.375em;
    margin: 0 auto;
    padding-top: 0;
    text-align: center;
    width: 70%;
  }
`;

export default class TPRSContact extends Component {
  render() {
    const { backgroundImageUrl, roofImageUrl, backEvent, title } = this.props;

    return (
      <ContactBody backgroundImageUrl={backgroundImageUrl}>
        <ContentHeader>
          <BackLink onClick={backEvent}>
            {sessionStorage.getItem('widget-language') === 'es-us' ? 'Atrás' : 'Back'}
          </BackLink>
        </ContentHeader>
        <RoofingDiagram imageUrl={roofImageUrl} />
        <Content>
          <Heading>{title}</Heading>
        </Content>
      </ContactBody>
    );
  }
}
